import { AccredibleChipComponentModule } from '@accredible-frontend-v2/new-components/chip';
import { AccredibleLinkComponentModule } from '@accredible-frontend-v2/new-components/link';
import { AccredibleContentHeaderComponent } from '@accredible-frontend-v2/new-components/ui-common';
import {
  AccredibleWizardComponent,
  AccredibleWizardStep,
} from '@accredible-frontend-v2/new-components/wizard';
import { AccredibleLanguageService } from '@accredible-frontend-v2/services/language';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    AccredibleContentHeaderComponent,
    AccredibleWizardComponent,
    TranslocoModule,
    AccredibleChipComponentModule,
    AccredibleLinkComponentModule,
  ],
  selector: 'db-checkout-header',
  templateUrl: 'checkout-header.component.html',
  styleUrls: ['checkout-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckoutHeaderComponent {
  private readonly _language = inject(AccredibleLanguageService);

  subscribed = input<boolean>();

  backNavigation = {
    v1Route: 'issuer.dashboard.billing.status',
    hrefUrl: '/issuer/dashboard/billing/status',
  };

  steps: AccredibleWizardStep[] = [
    { label: this._language.translate('checkout-header.steps.customize_plan') },
    { label: this._language.translate('checkout-header.steps.payment') },
  ];
}
